import { motion } from 'framer-motion';
import React from 'react';
import { useMediaQuery } from 'react-responsive';

function TelehealthModal() {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
  return (
    <div className="w-full flex flex-col justify-center items-center gap-4 sm:gap-6 md:gap-10 max-w-[1200px] mx-auto px-4 md:px-10 mb-10 relative z-10">
      <motion.div
        id="TelehealthModal"
        initial={{ x: isMobile ? '0 ' : '-50%', opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{
          duration: 1,
          type: 'spring',
          stiffness: 120,
          damping: 12,
        }}
        style={{
          background:
            'linear-gradient(-45deg, #493F99 0%, #755EA8 67%, #D36CAA 100%)',
        }}
        className="w-full rounded-2xl md:rounded-[50px] p-6 md:px-14 md:pt-10 md:pb-16"
      >
        <div className="flex flex-col lg:flex-row lg:justify-between gap-4 lg:gap-8 w-full">
          <div className="flex flex-col gap-4 flex-1 justify-center font-[500]">
            <p className="text-white text-[24px] lg:text-[28px] xl:text-[35px]">
              <span className=" font-bold italic">
                Telehealth has emerged as a transformative tool in the field of
                pediatric therapy,
              </span>{' '}
              bringing numerous benefits to children and families. From
              increased accessibility and convenience to fostering parent
              involvement and collaboration, telehealth opens new possibilities
              for effective therapy and continued progress.
            </p>
            <p className="text-white text-[24px] lg:text-[28px] xl:text-[35px] mt-6">
              Embracing the power of technology, we can deliver quality care,
              support children's developmental needs, and make a positive impact
              on their lives, no matter the distance.
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default TelehealthModal;
